<template>
  <div class="preview">
    <div class="preview__inner">
      <div class="preview__header">
        <el-row>
          <el-col :span="12">
            <h2>Podgląd wiadomości e-mail</h2>
          </el-col>
        </el-row>
      </div>
      <div class="email">
        <div class="email-content">
          <div
            class="line short"
            style="margin-bottom: 30px;"
          />
          <div class="line long full" />
          <div class="line long" />
          <div
            class="line long full"
            style="margin-bottom: 30px;"
          />
          <div class="line long full" />
          <div class="line long" />
          <div> --</div>
        </div>
        <div
          ref="preview"
          class="email-preview"
        >
          <component
            :is="signatureTemplate"
            ref="template"
          />
        </div>
      </div>
      <div class="actions">
        <el-button-group>
          <el-button
            size="small"
            type
            @click="viewSource"
          >Pokaż źródło</el-button>
          <el-button
            ref="copyHTML"
            size="small"
            @click="copyHTML"
          >Kopiuj jako HTML</el-button>
        </el-button-group>
          <el-button
            size="small"
            type="primary"
            @click="copySelect"
          >Zaznacz i skopiuj</el-button>
        <br>
        <el-popover
          placement="top"
          width="360"
        >
          <el-button
            slot="reference"
            size="small"
            type="text"
          >Pokaż instrukcję</el-button>
          <h3>Kopiowanie do poczty Develtio:</h3>
          <p>Skorzystaj z przycisku "Zaznacz i skopiuj" aby skopiować do swojego schowka prawidłowy kod stopki. Następnie wklej zawartość schowka do pola stopki w gmail.com.</p>
          <h3>Inne klienty pocztowe:</h3>
          <p>Niektóre klienty pocztowe obsługują wprowadzenie stopki w postaci kodu HTML. W takim przypadku użyj przycisku "Kopiuj jako HTML" i zawartość schowka wklej w odpowiednie pole wybranego klienta pocztowego.</p>
        </el-popover>
      </div>
      <textarea
        ref="html"
        style="opacity: 0"
      />
    </div>
    <el-dialog
      title="Twoja stopka"
      :visible.sync="showSource"
    >
      <p>Skopiuj poniższy kod HTML i wklej go w odpowiednie miejsce wybranego klienta pocztowego</p>
      <br>
      <el-input
        ref="dialogSource"
        v-model="html"
        type="textarea"
        :rows="10"
      />
      <div
        style="text-align: right;"
        class="dialog-actions"
      >
        <el-button
          type="primary"
          @click="copySource"
        >Kopiuj</el-button>
      </div>
    </el-dialog>
    <success-promo :show.sync="showSuccessPromo" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import SuccessPromo from './SuccessPromo'

export default {
  name: 'Preview',

  components: {
    SuccessPromo
  },

  data () {
    return {
      html: '',
      showSource: false,
      showSuccessPromo: false
    }
  },

  computed: {
    ...mapState(['template']),
    ...mapGetters({
      basic: 'getBasic',
      template: 'getTemplate'
    }),
    signatureTemplate () {
      const template = this.template.selected
      return () => import(`./templates/${template}`)
    },
    selectTemplate: {
      get () {
        return this.template.selected
      },
      set (v) {
        this.$store.dispatch('updateTemplate', v)
      }
    }
  },

  methods: {
    parseHTML () {
      let htmlWithImage = '<!doctype html><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head><title>Develtio</title><!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge"><!--<![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style type="text/css">#outlook a { padding:0; }\n' +
        '          body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }\n' +
        '          table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }\n' +
        '          img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }\n' +
        '          p { display:block;margin:13px 0; }</style><!--[if mso]>\n' +
        '        <xml>\n' +
        '        <o:OfficeDocumentSettings>\n' +
        '          <o:AllowPNG/>\n' +
        '          <o:PixelsPerInch>96</o:PixelsPerInch>\n' +
        '        </o:OfficeDocumentSettings>\n' +
        '        </xml>\n' +
        '        <![endif]--><style type="text/css">@media only screen and (max-width:480px) {\n' +
        '      table.mjfwm { width: 100% !important; }\n' +
        '      td.mjfwm { width: auto !important; }\n' +
        '    }</style><style type="text/css">@media (max-width: 480px) { .links a { font-size: 10px !important; } .details { padding-top: 15px; } }</style></head><body style="word-spacing:normal;">[placeholder]</body></html>';

      let htmlWithoutImage = '<!doctype html><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head><title>Develtio</title><!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge"><!--<![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style type="text/css">#outlook a { padding:0; }\n' +
        '          body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }\n' +
        '          table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }\n' +
        '          img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }\n' +
        '          p { display:block;margin:13px 0; }</style><!--[if mso]>\n' +
        '        <xml>\n' +
        '        <o:OfficeDocumentSettings>\n' +
        '          <o:AllowPNG/>\n' +
        '          <o:PixelsPerInch>96</o:PixelsPerInch>\n' +
        '        </o:OfficeDocumentSettings>\n' +
        '        </xml>\n' +
        '        <![endif]--><style type="text/css">@media only screen and (max-width:480px) {\n' +
        '      table.mjfwm { width: 100% !important; }\n' +
        '      td.mjfwm { width: auto !important; }\n' +
        '    }</style><style type="text/css">@media (max-width: 480px) { .links a { font-size: 10px !important; } .details { padding-top: 15px; } .details td { border: 0 !important; } .socials { padding-top: 0 !important; } }</style></head><body style="word-spacing:normal;">[placeholder]</body></html>';

      if (this.basic.fields[0].value != '') {
        return htmlWithImage.replace('[placeholder]', this.$refs.template.$el.outerHTML.replace(/<!---->/g, ''))
      } else {
        return htmlWithoutImage.replace('[placeholder]', this.$refs.template.$el.outerHTML.replace(/<!---->/g, ''))
      }
    },
    copyHTML () {
      this.$refs.html.innerHTML = this.parseHTML()
      this.$refs.html.select()
      document.execCommand('copy')
      this.showSuccessPromo = true
    },
    copySelect () {
      if (window.getSelection) {
        let range = document.createRange()
        range.selectNode(this.$refs.preview.querySelector('.email-preview div'))
        window.getSelection().removeAllRanges()
        window.getSelection().addRange(range)
        document.execCommand('copy')
        this.showSuccessPromo = true
      }
    },
    viewSource () {
      this.html = this.parseHTML()
      this.showSource = true
    },
    copySource () {
      this.$refs.dialogSource.select()
      document.execCommand('copy')
      this.showSource = false
      this.showSuccessPromo = true
    }
  }
}
</script>

<style lang="scss">
@import "../assets/scss/variables.scss";

$padding-inner: 40px 50px 20px 50px;

.preview {
  background-color: #f6f6f6;
  overflow-y: auto;
  display: grid;
  grid-template-rows: 1fr 50px;
  &__header {
    margin-bottom: 20px;
    h2 {
      line-height: 0;
    }
  }
  &__inner {
    max-width: 900px;
    padding: $padding-inner;
  }
  p {
    margin: 0;
  }
  .actions {
    text-align: right;
    margin-top: 20px;
  }
}
.email {
  min-height: 350px;
  width: 100%;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  &-content {
    padding: 20px;
    p {
      line-height: 1.5em;
      margin-bottom: 10px;
      font-size: 13px;
    }
    .line {
      height: 10px;
      background-color: #eee;
      margin: 10px 0;
      border-radius: 2px;
      &.short {
        width: 30%;
      }
      &.long {
        width: 90%;
      }
      &.half {
        width: 50%;
      }
      &.full {
        width: 100%;
      }
    }
    .flex {
      display: flex;
      width: 100%;
      margin-bottom: -10px;
      .column-1 {
        .line {
          &:first-of-type {
            margin-top: 0;
          }
        }
      }
      .column-1,
      .column-2 {
        flex-grow: 1;
      }
      .column-1 {
        width: 100%;
      }
      .column-2 {
        flex-shrink: 0;
        min-width: 320px;
      }
    }
  }
  &-preview {
    padding: 20px;
  }
  .placeholder {
    height: 100px;
    width: 100px;
    background-color: #eee;
  }
}
.setup-instruction {
  font-size: 12px;
}
.el-popover {
  word-break: normal !important;
}
.dialog-actions {
  text-align: right;
  margin-top: 20px;
}
.link {
  text-decoration: underline;
  color: $color-primary;
  cursor: pointer;
}
</style>
